<template>
  <div class="azure-callback-container">
    <div class="callback-content">
      <div v-if="loading" class="loading-state">
        <div class="spinner"></div>
        <h2>Autenticando con Microsoft...</h2>
        <p>Por favor espera mientras completamos tu inicio de sesión.</p>
      </div>

      <div v-else-if="error" class="error-state">
        <div class="error-icon">⚠</div>
        <h2>Error de Autenticación</h2>
        <p class="error-message">{{ errorMessage }}</p>
        <button @click="returnToLogin" class="btn-primary">
          Volver al Inicio de Sesión
        </button>
      </div>

      <div v-else-if="success" class="success-state">
        <div class="success-icon">✓</div>
        <h2>Autenticación Exitosa</h2>
        <p>Redirigiendo...</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AzureCallback',

  data() {
    return {
      loading: true,
      error: false,
      success: false,
      errorMessage: ''
    }
  },

  async mounted() {
    await this.handleCallback()
  },

  methods: {
    async handleCallback() {
      try {
        // Check for Azure AD errors in the callback URL
        const params = new URLSearchParams(window.location.search)
        if (params.get('error')) {
          throw new Error(params.get('error_description') || 'Error de autenticación de Azure AD')
        }

        // SEC-3 fase 2: los tokens ya no viajan por la URL — el backend dejó
        // la cookie HttpOnly con el refresh token; la sesión (access token en
        // memoria + datos de usuario) se establece vía silent refresh.
        await this.$store.dispatch('restoreSession')

        this.success = true
        this.loading = false

        // Redirect to dashboard after short delay
        setTimeout(() => {
          this.$router.push({ name: 'Home' })
        }, 1000)

      } catch (err) {
        console.error('Azure callback error:', err)
        this.error = true
        this.loading = false
        this.errorMessage = err.response?.data?.error ||
                           err.message ||
                           'Ocurrió un error durante la autenticación'
      }
    },

    returnToLogin() {
      this.$router.push({ name: 'Login' })
    }
  }
}
</script>

<style scoped>
.azure-callback-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.callback-content {
  background: white;
  border-radius: 12px;
  padding: 3rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  text-align: center;
  min-width: 400px;
}

/* Loading State */
.loading-state h2 {
  color: #333;
  margin: 1.5rem 0 0.5rem;
  font-size: 1.5rem;
}

.loading-state p {
  color: #666;
  margin: 0;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Error State */
.error-state .error-icon {
  font-size: 4rem;
  color: #e74c3c;
  margin-bottom: 1rem;
}

.error-state h2 {
  color: #e74c3c;
  margin: 0 0 1rem;
  font-size: 1.5rem;
}

.error-message {
  color: #666;
  margin: 0 0 2rem;
  padding: 1rem;
  background: #ffeaea;
  border-radius: 6px;
  border-left: 4px solid #e74c3c;
}

/* Success State */
.success-state .success-icon {
  font-size: 4rem;
  color: #27ae60;
  margin-bottom: 1rem;
}

.success-state h2 {
  color: #27ae60;
  margin: 0 0 0.5rem;
  font-size: 1.5rem;
}

.success-state p {
  color: #666;
}

/* Button */
.btn-primary {
  background: #667eea;
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s ease;
}

.btn-primary:hover {
  background: #5568d3;
}

.btn-primary:active {
  transform: translateY(1px);
}

/* Responsive */
@media (max-width: 480px) {
  .callback-content {
    min-width: auto;
    width: 90%;
    padding: 2rem;
  }
}
</style>
